import * as Yup from 'yup';
export var OptionalEmail = function () {
    return Yup.string().email('Must be a valid email address');
};
export var RequiredEmail = function () { return OptionalEmail().required('Cannot be blank'); };
